/** Canonical employment_status values (matches employees.employment_status enum). */

export const EMPLOYMENT_STATUS_OPTIONS = [
  { label: 'Active', value: 'Active' },
  { label: 'Suspended', value: 'Suspended' },
  { label: 'Terminated', value: 'Terminated' },
  { label: 'Resigned', value: 'Resigned' },
  { label: 'Quit', value: 'Quit' },
  { label: 'Blacklisted', value: 'Blacklisted' }
];

export const DEPARTURE_EMPLOYMENT_STATUSES = ['Terminated', 'Resigned', 'Quit', 'Blacklisted'];

export const AWAY_EMPLOYMENT_STATUSES = ['Suspended'];

export const WORKING_EMPLOYMENT_STATUSES = ['Active'];

/** Full employment_status list for bulk assign (departure asks for extra fields). */
export const BULK_EMPLOYMENT_STATUS_OPTIONS = [
  { label: 'Active', value: 'Active', meta: 'Currently employed' },
  { label: 'Suspended', value: 'Suspended', meta: 'Temporarily inactive' },
  { label: 'Terminated', value: 'Terminated', meta: 'Employment ended by the company' },
  { label: 'Resigned', value: 'Resigned', meta: 'Left by resignation' },
  { label: 'Quit', value: 'Quit', meta: 'Left without a formal resignation' },
  { label: 'Blacklisted', value: 'Blacklisted', meta: 'Not eligible for rehire' }
];

export const PAST_EMPLOYMENT_STATUS_OPTIONS = [
  { label: 'Suspended', value: 'Suspended' },
  { label: 'Terminated', value: 'Terminated' },
  { label: 'Resigned', value: 'Resigned' },
  { label: 'Quit', value: 'Quit' },
  { label: 'Blacklisted', value: 'Blacklisted' }
];

export const EMPLOYMENT_STATUS_TAG_SEVERITY = {
  Active: 'success',
  Rehired: 'info',
  Suspended: 'warn',
  Terminated: 'danger',
  Resigned: 'secondary',
  Quit: 'warn',
  Blacklisted: 'danger'
};

export const isDepartureEmploymentStatus = (status) =>
  DEPARTURE_EMPLOYMENT_STATUSES.includes(String(status || '').trim());

export const isAwayEmploymentStatus = (status) =>
  AWAY_EMPLOYMENT_STATUSES.includes(String(status || '').trim());

export const isWorkingEmploymentStatus = (status) =>
  WORKING_EMPLOYMENT_STATUSES.includes(String(status || '').trim());

/**
 * Account email / role / password are required only when login is enabled
 * and employment is not a departure status.
 * Matches manageEmployees: Active / Suspended may have login off;
 * Terminated / Resigned / Quit / Blacklisted cannot have login on.
 */
export const isAccountLoginRequired = ({ isActive, employmentStatus } = {}) => {
  if (isActive === false || isActive === 0) return false;
  if (isDepartureEmploymentStatus(employmentStatus)) return false;
  return true;
};

/** Any status other than the default Active roster state. */
export const isUnusualEmploymentStatus = (status) => {
  const normalized = String(status || '').trim();
  return normalized !== '' && normalized !== 'Active';
};

/** Human label for leave_reason when shown next to an unusual status. */
export const employmentStatusReasonLabel = (status) => {
  const normalized = String(status || '').trim();
  if (normalized === 'Blacklisted') return 'Blacklist reason';
  if (isDepartureEmploymentStatus(normalized)) return 'Leave reason';
  if (normalized === 'Suspended') return 'Reason for Suspension';
  return 'Status note';
};

/** Date field label: expected return for Suspended, end date otherwise. */
export const employmentStatusEndDateLabel = (status) => {
  if (isAwayEmploymentStatus(status)) return 'Expected Return Date';
  return 'End Date';
};

export const pastEmploymentStatusDotClass = (status) => {
  const s = String(status || '').trim();
  if (s === 'Terminated' || s === 'Blacklisted') return 'past-table__status-dot--terminated';
  if (s === 'Resigned') return 'past-table__status-dot--resigned';
  if (s === 'Suspended') return 'past-table__status-dot--suspended';
  if (s === 'Quit') return 'past-table__status-dot--quit';
  return 'past-table__status-dot--resigned';
};
